module.exports = __webpack_public_path__ + "img/check-mark-circle3.d6d545a9.png";